// The lobby side panel (a layout with `panel: true`, e.g. `lobby-panel`): the caption of the tour stop on screen
// (api.tours.on('stop')) above that stop's place card. Between tours it names the resort.
import { html } from '../dom.js';
import { GENERAL } from '../content.js';

export function lobbyPanel(c) {
  const { T, tx } = c;
  let ev = null; // the playing tour's `stop` event (VIS-226: what it shows; 2026-10-31: its words, `caption`)
  function draw() {
    const el = document.querySelector('#lobby .lobby-cap'); if (!el) return;
    // VIS-82: "Nothing" turns the stop's text off here too (VIS-226: the tour's own choice). The words are the event's
    // (owner's pick Q6 A, 2026-10-31: the stop's own, else the place's name and the first line of its card: tours.js)
    const cap = (ev?.show ?? c.v('tours.show')) === 'none' ? null : ev?.caption;
    el.querySelector('.eyebrow').hidden = !ev;
    el.querySelector('h2').textContent = tx(cap?.title) || tx(GENERAL.name);
    el.querySelector('p').textContent = cap ? tx(cap.text) : tx(GENERAL.place);
  }
  return {
    /** The panel holds the place card (#card), so the card of a stop opens inside it. */
    html: () => html`<aside id="lobby" class="shell"><div class="core">
      <div class="lobby-cap"><span class="eyebrow">${T('lobby.label')}</span><h2></h2><p></p></div>
      <article id="card" aria-live="polite"></article>
    </div></aside>`,
    draw,
    /** @param {import('../settings/typedefs.js').ToursEvent | null} e  a `stop` event, or null when the tour is over */
    show(e) { ev = e?.stop ? e : null; draw(); },
  };
}
